import { html, View } from 'rune-ts';
import { CreatorTypeS } from '../../../../../features/Creator/outbound/share';
import { makeSubScreenNavigate, makeUtilScreenNavigate } from '../../../../../shared/app/navigate';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { dataStr } from '../../../../../shared/util/dataStr';
import { getResizedImage100WebpUrl } from '../../../../../shared/util/getResizedImageUrl';
import { makeDefaultProfileImg } from '../../../../../shared/util/helper';
import { getSharedData } from '../../../../../shared/util/rune';
import { makePlusUrl } from '../../../../../shared/util/url';
import { MShopThinIcon } from '../../../../components/atoms/Icon';
import klass from './PlusCreator.module.scss';
import { SectionTitle } from '@services/MarppleShop/renderApp/components/cells/SectionTitle/SectionTitle.ts';
import { SeeMoreLinkPlugin } from '@services/MarppleShop/renderApp/components/cells/SectionTitle/plugins';

const default_img = makeDefaultProfileImg(352);

export type PlusCreatorProps = {
  plus_crew: {
    domain_name: string;
  };
  popular_creators: CreatorTypeS.CreatorCardType[];
  is_mobile: boolean;
};

interface PlusCreatorOption {
  klass?: string;
}

export class PlusCreatorView extends View<CreatorTypeS.CreatorCardType> {
  constructor(
    data: CreatorTypeS.CreatorCardType,
    private option: PlusCreatorOption = {},
  ) {
    super(data, option);
  }

  protected override template() {
    const is_mobile = !!getSharedData(this)?.is_mobile;
    const plus_crew = getSharedData(this)?.plus_crew;

    return html`
      <a
        href="/${ET.lang}/${this.data.domain_name}"
        data-post-message="${dataStr(
          makeSubScreenNavigate(
            plus_crew
              ? makePlusUrl(plus_crew.domain_name, `/${ET.lang}/${this.data.domain_name}`)
              : `/${ET.lang}/${this.data.domain_name}`,
          ),
        )}"
        class="${klass.creator} ${this.option.klass}"
      >
        <div class="${klass.image_container}">
          <img
            class="${klass.image}"
            src="${this.data.thumbnail_img
              ? getResizedImage100WebpUrl(this.data.thumbnail_img, 352)
              : default_img}"
            alt=""
          />
        </div>
        <div class="${klass.name_container}">
          <span class="${klass.name_wrapper}">
            <span class="${klass.name} ${typoPcMo({ is_mobile, pc: '16_bold', mo: '14_bold' })}"
              >${html.preventEscape(this.data.name ?? '')}</span
            >
            <span class="${klass.icon}">${MShopThinIcon}</span>
          </span>

          <span class="${klass.category} ${typoPcMo({ is_mobile, pc: '14_medium', mo: '14_medium' })}"
            >${this.data.seller_type}</span
          >
        </div>
      </a>
    `;
  }
}

export class PlusCreator extends View<PlusCreatorProps> {
  private readonly plusCreatorListUrl: string;

  constructor(props: PlusCreatorProps) {
    super(props);
    this.plusCreatorListUrl = makePlusUrl(this.data.plus_crew.domain_name, `/${ET.lang}/@/creators`);
  }

  protected override template() {
    return html`
      <div class="${klass.container}">
        <div class="${klass.title_wrap}">
          ${new SectionTitle({
            title_props: {
              title: T('mshop::Menu::Creator'),
              size: this.data.is_mobile ? 'large' : 'xLarge',
            },
            plugins: [
              new SeeMoreLinkPlugin({
                see_more_link: this.plusCreatorListUrl,
                navigate: makeUtilScreenNavigate(this.plusCreatorListUrl),
                size: this.data.is_mobile ? 'xSmall' : 'medium',
              }),
            ],
          })}
        </div>
        <div class="${klass.list}">
          ${this.data.popular_creators.map((menu) => new PlusCreatorView(menu))}
        </div>
      </div>
    `;
  }
}
